import * as loopback from '../loopbackConfig'

//   http://localhost:8081/api/Products
//export const url = loopback.protocol +`://` + loopback.host + `:` + loopback.port + `/api/` ;

//
//https://jyushin-backend.herokuapp.com/api
export const url = loopback.protocol + `://` + loopback.host + `/api/`;